/**
 * @generated SignedSource<<c7f442f11dd58d84f3f3df0bfc5bd885>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RequestAccessQuery$variables = {
  guid: string;
  streamId: string;
};
export type RequestAccessQuery$data = {
  readonly personalStreams: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "NoteStream";
        readonly archived: boolean | null;
        readonly fromSignupForViewer: boolean;
        readonly id: string;
        readonly index: number | null;
        readonly isTodoStream: boolean;
        readonly starred: boolean;
        readonly userCount: number;
        readonly " $fragmentSpreads": FragmentRefs<"StreamLink_stream">;
      } | null;
    } | null>;
  };
  readonly restrictedNoteStream: {
    readonly id: string;
    readonly urlForViewer: string | null;
    readonly userWithAccess: {
      readonly email: string;
      readonly fullName: string;
      readonly id: string;
      readonly internalAttributes: {
        readonly slackDmLink: string | null;
        readonly teamsDmLink: string | null;
      } | null;
      readonly isActive: boolean;
    } | null;
  } | null;
};
export type RequestAccessQuery = {
  response: RequestAccessQuery$data;
  variables: RequestAccessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "guid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "streamId"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": "personal"
  },
  {
    "kind": "Literal",
    "name": "userOrder",
    "value": true
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archived",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTodoStream",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "index",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fromSignupForViewer",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "starred",
  "storageKey": null
},
v10 = [
  {
    "kind": "Variable",
    "name": "guid",
    "variableName": "guid"
  },
  {
    "kind": "Variable",
    "name": "streamId",
    "variableName": "streamId"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlForViewer",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slackDmLink",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamsDmLink",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v18 = [
  (v3/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guid",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willBeRecorded",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAllDay",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeBlockType",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "ConferenceCall",
  "kind": "LinkedField",
  "name": "conferenceCalls",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provider",
      "storageKey": null
    },
    (v17/*: any*/)
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Calendar",
  "kind": "LinkedField",
  "name": "calendar",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RequestAccessQuery",
    "selections": [
      {
        "alias": "personalStreams",
        "args": (v1/*: any*/),
        "concreteType": "NoteStreamConnection",
        "kind": "LinkedField",
        "name": "noteStreams",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStreamEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "StreamLink_stream"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "noteStreams(first:100,type:\"personal\",userOrder:true)"
      },
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "RestrictedNoteStream",
        "kind": "LinkedField",
        "name": "restrictedNoteStream",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "userWithAccess",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RequestAccessQuery",
    "selections": [
      {
        "alias": "personalStreams",
        "args": (v1/*: any*/),
        "concreteType": "NoteStreamConnection",
        "kind": "LinkedField",
        "name": "noteStreams",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStreamEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerLastSeenAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "latestNoteEditedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isExternal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasExternalUsers",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HomePanelGroup",
                    "kind": "LinkedField",
                    "name": "homePanelGroup",
                    "plural": false,
                    "selections": (v18/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "otherUser",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "image",
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isConfigured",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasReceivedInvites",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "relationshipToViewer",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isGuest",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isTopUser",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "onlyReportManager",
                            "value": true
                          }
                        ],
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "activeRecurring1on1Event",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": "activeRecurring1on1Event(onlyReportManager:true)"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "linkedEvent",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "nextOccurrence",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "end",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v19/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "finalOccurrence",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Note",
                    "kind": "LinkedField",
                    "name": "latestNote",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "eventStart",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "eventEnd",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "finished",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "event",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v19/*: any*/),
                          (v21/*: any*/),
                          (v20/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteStreamPublicLink",
                    "kind": "LinkedField",
                    "name": "publicLink",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enabled",
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HomePanelGroup",
                        "kind": "LinkedField",
                        "name": "homePanelGroup",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "HomePanelObjectInterface",
                    "abstractKey": "__isHomePanelObjectInterface"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "noteStreams(first:100,type:\"personal\",userOrder:true)"
      },
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "RestrictedNoteStream",
        "kind": "LinkedField",
        "name": "restrictedNoteStream",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "userWithAccess",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "32c08af333d26381b9ccb089f906806d",
    "id": null,
    "metadata": {},
    "name": "RequestAccessQuery",
    "operationKind": "query",
    "text": "query RequestAccessQuery(\n  $guid: String!\n  $streamId: ID!\n) {\n  personalStreams: noteStreams(type: \"personal\", userOrder: true, first: 100) {\n    edges {\n      node {\n        __typename\n        id\n        archived\n        isTodoStream\n        index\n        userCount\n        fromSignupForViewer\n        starred\n        ...StreamLink_stream\n      }\n    }\n  }\n  restrictedNoteStream(guid: $guid, streamId: $streamId) {\n    id\n    urlForViewer\n    userWithAccess {\n      id\n      email\n      fullName\n      isActive\n      internalAttributes {\n        slackDmLink\n        teamsDmLink\n        id\n      }\n    }\n  }\n}\n\nfragment GroupsMenu_stream on NoteStream {\n  ...HomePanelGroupsMenu_object\n  id\n  homePanelGroup {\n    id\n  }\n}\n\nfragment HomePanelGroupsMenu_object on HomePanelObjectInterface {\n  __isHomePanelObjectInterface: __typename\n  id\n  __typename\n  ... on NoteStream {\n    type\n  }\n  homePanelGroup {\n    id\n    name\n  }\n}\n\nfragment OneOnOneLink_user on User {\n  id\n  fullName\n  image\n  isActive\n  isConfigured\n  email\n  hasReceivedInvites\n  relationshipToViewer\n  isGuest\n  isTopUser\n  activeRecurring1on1Event(onlyReportManager: true) {\n    id\n  }\n}\n\nfragment RecordIcon_event on Event {\n  id\n  guid\n  willBeRecorded\n  start\n  status\n  isAllDay\n  timeBlockType\n  conferenceCalls {\n    provider\n    url\n  }\n  calendar {\n    id\n  }\n}\n\nfragment StreamLink_stream on NoteStream {\n  id\n  type\n  url\n  displayName\n  userCount\n  viewerLastSeenAt\n  latestNoteEditedAt\n  isExternal\n  hasExternalUsers\n  ...GroupsMenu_stream\n  otherUser {\n    ...OneOnOneLink_user\n    id\n  }\n  linkedEvent {\n    id\n    guid\n    nextOccurrence {\n      start\n      end\n      ...RecordIcon_event\n      id\n    }\n    finalOccurrence\n  }\n  latestNote {\n    id\n    eventStart\n    eventEnd\n    finished\n    event {\n      id\n      guid\n      ...RecordIcon_event\n    }\n  }\n  publicLink {\n    enabled\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "835268a002ed16bd139cb6367639a5cb";

export default node;
